import { useCallback } from 'react';
import { ToggleType } from '../../types';
import { getNextRuleAndGroup } from '../rule-group-list/get-next-rule-and-group';
const NEW_RULE_EXPAND_DELAY = 800;
const PREV_RULE_COLLAPSE_DELAY = 400;
export const useOpenNextRule = _ref => {
  let {
    selectedRule,
    setSelectedItem,
    selectedGroup
  } = _ref;
  const openNextRule = useCallback(ruleGroups => {
    const {
      nextGroup,
      nextRule
    } = getNextRuleAndGroup(ruleGroups, selectedGroup, selectedRule);
    if ((nextRule == null ? void 0 : nextRule.id) !== (selectedRule == null ? void 0 : selectedRule.id)) {
      const selectedRuleIndex = (selectedGroup == null ? void 0 : selectedGroup.ruleResults.findIndex(rule => rule.id === (selectedRule == null ? void 0 : selectedRule.id))) ?? -1;
      selectedRule == null || selectedRule.onRuleToggle == null || selectedRule.onRuleToggle(ToggleType.Collapse, selectedRuleIndex, false);
      setSelectedItem({
        selectedGroup,
        selectedRule: null
      });
      setTimeout(() => {
        setTimeout(() => {
          const nextRuleIndex = (nextGroup == null ? void 0 : nextGroup.ruleResults.findIndex(rule => rule.id === (nextRule == null ? void 0 : nextRule.id))) ?? -1;
          nextRule == null || nextRule.onRuleToggle == null || nextRule.onRuleToggle(ToggleType.Expand, nextRuleIndex, false);
          setSelectedItem({
            selectedGroup: nextGroup,
            selectedRule: nextRule
          });
        }, NEW_RULE_EXPAND_DELAY);
      }, PREV_RULE_COLLAPSE_DELAY);
    }
  }, [selectedGroup, selectedRule, setSelectedItem]);
  return {
    openNextRule
  };
};
//# sourceMappingURL=use-open-next-rule.js.map